import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppBridge, withNonce } from "@/lib/appBridge";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PublishedSite() {
  const { slug } = useParams();
  const [info, setInfo] = useState(null);
  const [missing, setMissing] = useState(false);
  const frame = useRef(null);
  const nonce = useAppBridge(frame, info?.app_id);

  useEffect(() => {
    fetch(`${BACKEND}/api/public/sites/${encodeURIComponent(slug)}`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((d) => { document.title = d.name; setInfo(d); })
      .catch(() => setMissing(true));
  }, [slug]);

  if (missing) {
    return (
      <main data-testid="published-site-not-found" className="noise grid min-h-screen place-items-center bg-[#07090E] px-6 text-center">
        <div>
          <p className="font-mono-tech text-xs uppercase tracking-widest text-cyan-400">// 404</p>
          <h1 className="mt-4 text-4xl font-extrabold text-white sm:text-5xl">Site not found</h1>
          <p className="mt-3 text-slate-400">This link isn't active right now.</p>
        </div>
      </main>
    );
  }
  if (!info) return <div className="fixed inset-0 bg-white" data-testid="published-site-loading" />;
  return (
    <iframe ref={frame} title={info.name} src={withNonce(`${BACKEND}/api/sites/${encodeURIComponent(slug)}/index.html`, nonce)} sandbox="allow-scripts allow-forms allow-popups"
      data-testid="published-site-frame" className="fixed inset-0 h-full w-full border-0 bg-white" />
  );
}
